"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCustomizeView = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const Search_1 = __importDefault(require("@mui/icons-material/Search"));
const material_1 = require("@mui/material");
const Drawer_1 = __importDefault(require("@mui/material/Drawer"));
const InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
const react_virtualized_auto_sizer_1 = __importDefault(require("react-virtualized-auto-sizer"));
const react_window_1 = require("react-window");
const styled_components_1 = require("styled-components");
const list_row_component_1 = require("./list-row.component");
const table_customize_view_styles_1 = require("./table-customize-view.styles");
const components_1 = require("../../../../../../components");
const utils_1 = require("../../../../../../utils");
const localization_1 = require("../../../../../../../localization");
const table_columns_1 = require("../../../../../../common/table-columns");
const LIST_ITEM_HEIGHT = 45;
const TableCustomizeView = ({ columns, setOrder, toggleCheck, isAllSelected, toggleSelectAll, checkIsColumnSelected, isOpen, isLoading, error, isApplyDisabled, onApply, onClose, isFilterEnabled, onFilterOpen, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const theme = (0, styled_components_1.useTheme)();
    const [searchTerm, SetSearchTerm] = (0, react_1.useState)('');
    const handleCheck = (0, react_1.useCallback)((column, isChecked) => {
        if (!column.static) {
            toggleCheck(column.id, isChecked);
        }
    }, [toggleCheck]);
    const filteredColumns = (0, react_1.useMemo)(() => (searchTerm === ''
        ? columns
        : columns === null || columns === void 0 ? void 0 : columns.filter(({ label }) => (0, utils_1.filterTextCaseInsensitive)(label, searchTerm))), [columns, searchTerm]);
    const checkedStatus = (0, react_1.useMemo)(() => filteredColumns.map(({ id }) => table_columns_1.BASE_COLUMNS.includes(id) || checkIsColumnSelected(id)), [filteredColumns, checkIsColumnSelected]);
    const showData = !isLoading && !error;
    return (react_1.default.createElement(Drawer_1.default, { open: isOpen, anchor: "right", onClose: onClose }, react_1.default.createElement(table_customize_view_styles_1.StyledCustomizeViewContainer, null, react_1.default.createElement(ui_components_1.Typography, { variant: "h6", gutterBottom: true, className: "customize-view-container-title" }, t({ key: 'VIEW_OPTION' })), isLoading && react_1.default.createElement(components_1.PreviewSkeleton, null), error && react_1.default.createElement(components_1.Alert, { severity: "error" }, error), showData && (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(table_customize_view_styles_1.StyledCustomizeViewHeader, null, react_1.default.createElement("div", { className: "title-container" }, t({ key: 'CONFIGURE_FIELDS' }), react_1.default.createElement(material_1.IconButton, { onClick: (event) => onFilterOpen(event.currentTarget) }, react_1.default.createElement(ui_components_1.Icon, { variant: 'filter', color: theme.palette.primary.main, fill: isFilterEnabled ? theme.palette.primary.main : theme.palette.common.white }))), react_1.default.createElement(ui_components_1.Button, { size: "small", onClick: () => toggleSelectAll() }, t({ key: isAllSelected ? 'CLEAR_SELECTION' : 'SELECT_ALL' }))), react_1.default.createElement(ui_components_1.TextField, { fullWidth: true, placeholder: t({ key: 'SEARCH' }), variant: "outlined", value: searchTerm, onChange: (e) => SetSearchTerm(e.target.value), InputProps: {
            startAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "start" }, react_1.default.createElement(Search_1.default, null))),
        } }), react_1.default.createElement("div", { className: 'list-container' }, react_1.default.createElement(react_virtualized_auto_sizer_1.default, null, ({ width, height }) => (react_1.default.createElement(react_window_1.FixedSizeList, { height: height, width: width, itemKey: (index, data) => data.items[index].id, itemSize: LIST_ITEM_HEIGHT, itemCount: filteredColumns.length, itemData: {
            items: filteredColumns,
            itemHeight: LIST_ITEM_HEIGHT,
            checkedStatus,
            onCheck: handleCheck,
            onOrderChanged: setOrder,
        } }, list_row_component_1.ListRow)))))), react_1.default.createElement(table_customize_view_styles_1.StyledCustomizeViewActionContainer, null, react_1.default.createElement(ui_components_1.Button, { rounded: true, onClick: onClose }, t({ key: 'CANCEL' })), react_1.default.createElement(ui_components_1.Button, { rounded: true, disabled: !showData || isApplyDisabled, variant: 'contained', onClick: onApply, color: "primary" }, t({ key: 'APPLY' }))))));
};
exports.TableCustomizeView = TableCustomizeView;
